export default __webpack_public_path__ + "static/media/CHARM.b7428d3d.svg";